import { render, staticRenderFns } from "./LEDPCB80.vue?vue&type=template&id=2fabf8a8&scoped=true&"
import script from "./LEDPCB80.vue?vue&type=script&lang=js&"
export * from "./LEDPCB80.vue?vue&type=script&lang=js&"
import style0 from "./LEDPCB80.vue?vue&type=style&index=0&id=2fabf8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fabf8a8",
  null
  
)

export default component.exports